// @dani verification - remove funding verification approval from tapebuilder when testing is complete

import { Box, Button, Text, useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { getCreditFacilityBySlug, useGraph } from './GraphContext';
import { errorToastConfig } from 'packages/common-frontend/constants';
import { getUnexpectedErrorMessage } from 'packages/common-frontend/utils';
import { useAdjudicateFundingRequestVerificationReportMutation } from 'packages/verifications/requests/requests.gql.generated';

type Props = {
  creditFacilitySlug: string;
  record: string;
};
export const FundingVerificationTabPanel = ({
  creditFacilitySlug,
  record,
}: Props) => {
  const toast = useToast();
  const graphContext = useGraph();

  const creditFacilityId = getCreditFacilityBySlug(
    graphContext,
    creditFacilitySlug,
  );

  finleyAssert(
    creditFacilityId,
    'creditFacilityId must exist for given creditFacilitySlug for Funding Verification',
  );

  const { records } = JSON.parse(record);
  const { id: verificationReportId, approvalReportArtifactId } = records[0];

  const artifactInstances = graphContext.state.artifactInstances;
  const fundingRequestApprovalReports = _.filter(
    artifactInstances,
    ({ artifactId }) => artifactId === approvalReportArtifactId,
  );

  const [
    adjudicateFundingRequestVerificationReport,
  ] = useAdjudicateFundingRequestVerificationReportMutation({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = getUnexpectedErrorMessage(err);
      toast(errorToastConfig);
    },
  });

  return (
    <Box width={1000} height={400} border="1px solid #ccc" padding="10px">
      <Text mb="10px">
        This is used for capital provider verification testing only.
      </Text>
      {!fundingRequestApprovalReports.length ? (
        <>
          <Button
            onClick={() => {
              return adjudicateFundingRequestVerificationReport({
                variables: {
                  verificationReportId,
                  action: 'approve',
                  note: 'Approved via Finley Admin',
                },
              });
            }}
            display="block"
            mb="10px"
          >
            Approve funding verification report
          </Button>
          <Button
            onClick={() => {
              return adjudicateFundingRequestVerificationReport({
                variables: {
                  verificationReportId,
                  action: 'reject',
                  note: 'Rejected via Finley Admin',
                },
              });
            }}
            display="block"
          >
            Deny funding verification report
          </Button>
        </>
      ) : (
        <Text>
          A funding approval report has already been created for this funding
          verification report.
        </Text>
      )}
    </Box>
  );
};
